import NavbarVTX from "../../../../../components/common/Navbar";
import Header from "../../../../../components/common/Header";
import { Container, FormCheck, Row, Col, Form } from "react-bootstrap";
import Button from "../../../../../components/common/Button";
import SectionHeading from "../../../../../components/common/SectionHeading";
import { useNavigate, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAppAction } from "../redux/action/getAppAction";
import { useForm } from "react-hook-form";
import { BusinessDetailsType } from "./types/BusinessDetailsType";
import { updateAppAction } from "../redux/action/updateAppAction";
import { updateStageAction } from "../redux/action/updateStageAction";
import { fieldValidationAction } from "../redux/action/fieldValidation";
import { ValidationErrorModal } from "../components/ValidationErrorModal";
import { getUserRole, getUserUid } from "../../../../../utils/tokenHandlers";
import { logoutConCurrLoginAction } from "../../../../auth/redux/action/logoutConCurrLoginAction";
import BackButton from "../../../../../components/common/BackButton";

const OpsApplicationUndertaking = () => {
  let { appId } = useParams();
  let customerId = Number(appId);
  let stage = `move_stage_form_filling_to_signing`;
  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp.data
  );
  let appStage = getAppSelector.stage;

  const navigate = useNavigate();
  const userRole = getUserRole();
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm<BusinessDetailsType>({});

  const [validationError, setValidationError] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    dispatch(getAppAction(customerId)).then((respose) => {
      // console.log(respose);
    });
  }, [dispatch, customerId]);

  const openValidationModal = (validationErr: string) => {
    setValidationError(validationErr);
    setShowValidationModal(true);
  };
  const isCPUser = getAppSelector.is_counterparty;

  const handleBack = () => {
    if (isCPUser) {
      navigate(`/key-person-details/${customerId}`);
    } else {
      navigate(`/keyperson/kyc-details/${customerId}`);
    }
  };

  useEffect(() => {
    reset({
      maker_declaration_accepted: getAppSelector.maker_declaration_accepted,
    });
  }, []);

  // useEffect(() => {
  //   if (appStage) {
  //     // console.log(appStage);
  //     if (
  //       appStage !== "New / Draft" ||
  //       appStage !== "Sent back to correction"
  //     ) {
  //       const userId = getUserUid();
  //       dispatch(logoutConCurrLoginAction(userId)).then((resp: any) => {
  //         // // console.log("Logout resp--", resp);
  //         if (userRole === "guest") {
  //           navigate("/");
  //         } else if (userRole === "maker" || userRole === "checker") {
  //           navigate("/ops/login");
  //         } else {
  //           <></>;
  //         }
  //       });
  //     }
  //   }
  // }, [appStage, dispatch, navigate, userRole]);

  const checkNavigate = () => {
    dispatch(fieldValidationAction({ customerId, stage })).then((response) => {
      // console.log("Api resp-->", response);
      if (response.payload.error) {
        const validationErr = response.payload.error.data.message;
        // console.warn(validationErr);
        openValidationModal(validationErr);
      } else {
        navigate(`/documentsigning/${customerId}`);
      }
    });
  };

  const cpUndertaking = (
    <ul>
      <li>
        We hereby provide consent for sharing the following documents: (a)
        Authorisation Document, Agreement, Proof of Identity, Proof of Address,
        Registration Certificate, Financials, Banks Account details,
        Constitution Document, Declarations, Details of shareholders &
        Directors, License copy, etc, as applicable; and (b) such other
        information as may be required by Vayana (IFSC) Private Limited (“VTX”),
        from time to time, to meet the purpose specified herein.
      </li>
      <li>
        We certify that the documents shared by us are genuine. If any document
        is found to be false, tampered with, fabricated, or misleading, we
        accept liability, including possible deregistration from VTX.
      </li>
      <li>
        In the event of any change in the information provided, we hereby agree
        to forthwith update VTX of such changes in writing.
      </li>
      <li>
        We consent to the utilization of the information provided by me for the
        purpose of availing the services from VTX’s platform.
      </li>
      <li>
        We consent to the utilization of the information provided by us for the
        following purposes: (a) Onboarding as a Participant on VTX’s platform;
        (b) verification (either by itself or through third party agencies) the
        Know Your Customer (KYC) details of related individuals and & KYB
        details of the entity, through contact point verification or any other
        method as per regulatory requirements.; and (c) sharing potential
        business opportunities of VTX and / or its affiliates.
      </li>
      <li>
        We have read and hereby accept VTX’s Privacy Policy and all applicable
        terms and conditions.
      </li>

      <li>
        We authorize VTX to upload/download the entity’s KYC details from the
        Central KYC (CKYC) Registry and agree to receive related notifications
        via SMS or email on the registered contact details.
      </li>
      <li>
        We affirm that the entity has no arrears of statutory dues and that no
        government inquiries, legal proceedings, prosecutions, or regulatory
        actions are pending or initiated against the entity, its promoters,
        directors, partners, proprietors, or beneficial owners. Furthermore, we
        confirm that neither the entity nor any of its promoters, directors,
        partners, trustees, or beneficial owners have been declared insolvent at
        any time.
      </li>
      <li>
        We authorize VTX and its representatives to conduct necessary
        verifications, including inquiries through credit information agencies
        and visits to any unit, location, branch, or office of the entity, as
        part of the registration process. We agree to furnish any additional
        information required by VTX for onboarding and compliance.
      </li>
      <li>
        We acknowledge that any delay or failure in processing transactions due
        to incomplete or incorrect information will not hold VTX or the
        financiers registered with VTX liable.
      </li>
      <li>
        We consent to submitting this application along with the Master
        Agreement and other required onboarding documents either with a physical
        signature and entity stamp or through digital/electronic signing.
      </li>
      <li>
        We authorize VTX, its agents, and representatives to disclose, share, or
        transfer entity-related information as required under regulatory
        provisions. This includes sharing details with regulatory authorities,
        compliance agencies, financiers, financial institutions, credit rating
        agencies, and verification partners for fraud prevention, compliance,
        and secure data verification.
      </li>
      <li>
        We declare that the details provided in this application and its
        annexures, including all enclosed/uploaded KYC documents, are true,
        correct, and complete to the best of our knowledge and belief. In case
        of any changes in the provided details, I/We undertake to update VTX
        immediately.
      </li>
      <li>
        The entity’s application is not intended to for the purpose of
        contravention of any Act, Rules, Regulations or any Statute or
        Legislation or any Notifications/ Directions issued by any governmental
        or statutory authority from time to time.
      </li>
      <li>
        We affirm that all transactions conducted through Vayana TradeXchange,
        both present and future, fully comply with the provisions of the Foreign
        Exchange Management Act (FEMA), 1999, wherever applicable.
      </li>
      <li>
        We undertake to provide all necessary documents and information as
        required by VTX before executing any transaction to ensure regulatory
        compliance. Any failure to comply may result in transaction rejection,
        and if any evasion is suspected, VTX reserves the right to report the
        matter to relevant authorities.
      </li>
      <li>
        We authorize VTX to act on instructions, communications, or documents
        sent via the official email ID of the authorized official(s) provided
        herein. These instructions reflect the internal decisions of the entity,
        and necessary supporting documents will be provided when required. We
        accept full responsibility for any losses arising from actions taken
        based on these instructions, acknowledging the risks associated with
        email communications. VTX may act on these instructions without
        requiring written confirmation and shall not be held liable for
        unauthorized communications.
      </li>
      <li>
        We acknowledge VTX’s right to maintain records of transactions and other
        related information for compliance and regulatory purposes.
      </li>
      <li>
        We agree to cooperate in resolving technical issues, including those
        arising from Force Majeure events.
      </li>
    </ul>
  );

  const buyerSellerUndertaking = (
    <ul>
      <li>
        We hereby provide consent for sharing the following documents: (a)
        Authorisation Document, Agreement, Proof of Identity, Proof of Address,
        Registration Certificate, Financials, Banks Account details,
        Constitution Document, Declarations, Details of shareholders &
        Directors, License copy, etc, as applicable; and (b) such other
        information as may be required by Vayana (IFSC) Private Limited (“VTX”),
        from time to time, to meet the purpose specified herein.
      </li>
      <li>
        We certify that the documents shared by us are genuine. If any document
        is found to be false, tampered with, fabricated, or misleading, we
        accept liability, including possible deregistration from VTX.
      </li>
      <li>
        In the event of any change in the information provided, we hereby agree
        to forthwith update VTX of such changes in writing.
      </li>
      <li>
        We consent to the utilization of the information provided by me for the
        purpose of availing the services from VTX’s platform.
      </li>
      <li>
        We consent to the utilization of the information provided by us for the
        following purposes: (a) Onboarding as a Participant on VTX’s platform;
        (b) verification (either by itself or through third party agencies) the
        Know Your Customer (KYC) details of related individuals and & KYB
        details of the entity, through contact point verification or any other
        method as per regulatory requirements.; and (c) sharing potential
        business opportunities of VTX and / or its affiliates.
      </li>
      <li>
        We have read and hereby accept VTX’s Privacy Policy and all applicable
        terms and conditions.
      </li>
      <li>
        We authorize VTX to upload/download the entity’s KYC details from the
        Central KYC (CKYC) Registry and agree to receive related notifications
        via SMS or email on the registered contact details.
      </li>
      <li>
        We affirm that the entity has no arrears of statutory dues and that no
        government inquiries, legal proceedings, prosecutions, or regulatory
        actions are pending or initiated against the entity, its promoters,
        directors, partners, proprietors, or beneficial owners. Furthermore, we
        confirm that neither the entity nor any of its promoters, directors,
        partners, trustees, or beneficial owners have been declared insolvent at
        any time.
      </li>
      <li>
        We authorize VTX and its representatives to conduct necessary
        verifications, including inquiries through credit information agencies
        and visits to any unit, location, branch, or office of the entity, as
        part of the registration process. We agree to furnish any additional
        information required by VTX for onboarding and compliance.
      </li>
      <li>
        We confirm that we have provided details of our Working Capital Account.
        If no such account exists, we confirm that the entity does not avail of
        any Cash Credit (CC), Overdraft (OD), or working capital facilities from
        any bank, NBFC, or financial institution.
      </li>
      <li>
        We acknowledge that any delay or failure in processing transactions due
        to incomplete or incorrect information will not hold VTX or the
        financiers registered with VTX liable.
      </li>
      <li>
        We consent to submitting this application along with the Master
        Agreement and other required onboarding documents either with a physical
        signature and entity stamp or through digital/electronic signing.
      </li>
      <li>
        We authorize VTX, its agents, and representatives to disclose, share, or
        transfer entity-related information as required under regulatory
        provisions. This includes sharing details with regulatory authorities,
        compliance agencies, financiers, financial institutions, credit rating
        agencies, and verification partners for fraud prevention, compliance,
        and secure data verification.
      </li>
      <li>
        We declare that the details provided in this application and its
        annexures, including all enclosed/uploaded KYC documents, are true,
        correct, and complete to the best of our knowledge and belief. In case
        of any changes in the provided details, I/We undertake to update VTX
        immediately.
      </li>
      <li>
        The entity’s application is not intended to for the purpose of
        contravention of any Act, Rules, Regulations or any Statute or
        Legislation or any Notifications/ Directions issued by any governmental
        or statutory authority from time to time.
      </li>
      <li>
        We affirm that all transactions conducted through Vayana TradeXchange,
        both present and future, fully comply with the provisions of the Foreign
        Exchange Management Act (FEMA), 1999, wherever applicable.
      </li>
      <li>
        We undertake to provide all necessary documents and information as
        required by VTX before executing any transaction to ensure regulatory
        compliance. Any failure to comply may result in transaction rejection,
        and if any evasion is suspected, VTX reserves the right to report the
        matter to relevant authorities.
      </li>
      <li>
        We authorize VTX to act on instructions, communications, or documents
        sent via the official email ID of the authorized official(s) provided
        herein. These instructions reflect the internal decisions of the entity,
        and necessary supporting documents will be provided when required. We
        accept full responsibility for any losses arising from actions taken
        based on these instructions, acknowledging the risks associated with
        email communications. VTX may act on these instructions without
        requiring written confirmation and shall not be held liable for
        unauthorized communications.
      </li>
      <li>
        We acknowledge VTX’s right to maintain records of transactions and other
        related information for compliance and regulatory purposes.
      </li>
      <li>
        We agree to cooperate in resolving technical issues, including those
        arising from Force Majeure events.
      </li>
      {/* <li>
        I/We authorize the VTX to act on instructions, communications, or
        documents sent via our official Email ID of Authorised official provided
        herein above. These instructions reflect our internal decisions, and
        I/we will provide necessary documents if needed. I/We accept
        responsibility for any losses due to actions taken based on these
        instructions, understanding email-related risks. VTX may act on these
        instructions without written confirmation. I/We are accountable for
        authenticity, and the VTX is not liable for unauthorized communication.
        I/We acknowledge the platform's record-keeping rights and agree to
        cooperate in resolving technical errors, including Force Majeure
        situations.
      </li>
      <li>
        I/we, affirm that the transaction/s conducted through Vayana
        TradeXchange, both present and future, fully comply with the provisions
        of the Foreign Exchange Management Act-1999. I/we undertake to provide
        all necessary information/documents as required by Vayana TradeXchange
        before any transaction, ensuring compliance with regulatory standards.
        I/we acknowledge that non-compliance may result in transaction refusal,
        and in case of suspected evasion, Vayana TradeXchange reserves the right
        to report the matter to relevant authorities.
      </li> */}
    </ul>
  );

  const financierUndertaking = (
    <ul>
      <li>
        We hereby provide consent for sharing the following documents: (a)
        Authorisation Document, Agreement, Proof of Identity, Proof of Address,
        Registration Certificate, Financials, Banks Account details,
        Constitution Document, Declarations, Details of shareholders &
        Directors, License copy, etc, as applicable; and (b) such other
        information as may be required by Vayana (IFSC) Private Limited (“VTX”),
        from time to time, to meet the purpose specified herein.
      </li>
      <li>
        We certify that the documents shared by us are genuine. If any document
        is found to be false, tampered with, fabricated, or misleading, we
        accept liability, including possible deregistration from VTX.
      </li>
      <li>
        In the event of any change in the information provided, we hereby agree
        to forthwith update VTX of such changes in writing.
      </li>
      <li>
        We consent to the utilization of the information provided by me for the
        purpose of availing the services from VTX’s platform.
      </li>
      <li>
        We consent to the utilization of the information provided by us for the
        following purposes: (a) Onboarding as a Participant on VTX’s platform;
        (b) verification (either by itself or through third party agencies) the
        Know Your Customer (KYC) details of related individuals and &amp; KYB
        details of the entity, through contact point verification or any other
        method as per regulatory requirements.; and (c) sharing potential
        business opportunities of VTX and / or its affiliates.
      </li>
      <li>
        We have read and hereby accept VTX’s Privacy Policy and all applicable
        terms and conditions.
      </li>
      <li>
        We authorize VTX to upload/download the entity’s KYC details from the
        Central KYC (CKYC) Registry and agree to receive related notifications
        via SMS or email on the registered contact details.
      </li>
      <li>
        We affirm that the entity has no arrears of statutory dues and that no
        government inquiries, legal proceedings, prosecutions, or regulatory
        actions are pending or initiated against the entity, its promoters,
        directors, partners, proprietors, or beneficial owners. Furthermore, we
        confirm that neither the entity nor any of its promoters, directors,
        partners, trustees, or beneficial owners have been declared insolvent at
        any time.
      </li>
      <li>
        We authorize VTX and its representatives to conduct necessary
        verifications, including inquiries through credit information agencies
        and visits to any unit, location, branch, or office of the entity, as
        part of the registration process. We agree to furnish any additional
        information required by VTX for onboarding and compliance.
      </li>
      <li>
        We acknowledge that any delay or failure in processing transactions due
        to incomplete or incorrect information will not hold VTX or any other
        participant registered with VTX liable.
      </li>
      <li>
        We consent to submitting this application along with the Master
        Agreement and other required onboarding documents either with a physical
        signature and entity stamp or through digital/electronic signing.
      </li>
      <li>
        We authorize VTX, its agents, and representatives to disclose, share, or
        transfer entity-related information as required under regulatory
        provisions. This includes sharing details with regulatory authorities,
        compliance agencies, financiers, financial institutions, credit rating
        agencies, and verification partners for fraud prevention, compliance,
        and secure data verification.
      </li>
      <li>
        We declare that the details provided in this application and its
        annexures, including all enclosed/uploaded KYC documents, are true,
        correct, and complete to the best of our knowledge and belief. In case
        of any changes in the provided details, I/We undertake to update VTX
        immediately.
      </li>
      <li>
        The entity’s application is not intended to for the purpose of
        contravention of any Act, Rules, Regulations or any Statute or
        Legislation or any Notifications/ Directions issued by any governmental
        or statutory authority from time to time.
      </li>
      <li>
        We affirm that all transactions conducted through Vayana TradeXchange,
        both present and future, fully comply with the provisions of the Foreign
        Exchange Management Act (FEMA), 1999, wherever applicable.
      </li>
      <li>
        We undertake to provide all necessary documents and information as
        required by VTX before executing any transaction to ensure regulatory
        compliance. Any failure to comply may result in transaction rejection,
        and if any evasion is suspected, VTX reserves the right to report the
        matter to relevant authorities.
      </li>
      <li>
        We authorize VTX to act on instructions, communications, or documents
        sent via the official email ID of the authorized official(s) provided
        herein. These instructions reflect the internal decisions of the entity,
        and necessary supporting documents will be provided when required. We
        accept full responsibility for any losses arising from actions taken
        based on these instructions, acknowledging the risks associated with
        email communications. VTX may act on these instructions without
        requiring written confirmation and shall not be held liable for
        unauthorized communications.
      </li>
      <li>
        We acknowledge VTX’s right to maintain records of transactions and other
        related information for compliance and regulatory purposes.
      </li>
      <li>
        We agree to cooperate in resolving technical issues, including those
        arising from Force Majeure events.
      </li>
    </ul>
  );

  const handleUndertakingSubmit = (data: any) => {
    if (appStage === "New / Draft" || appStage === "Sent back to correction") {
      const updateCustomerData = {
        ...data,
        // stage: "In Form Signing",
      };

      dispatch(updateAppAction({ customerId, updateCustomerData })).then(
        (response) => {
          // console.log(response);
          checkNavigate();
        }
      );
    } else {
      alert("Cannot edit application at this stage!");
    }
  };

  return (
    <>
      <NavbarVTX />
      <Header />
      <Container>
        <Row>
          <Col
            md={20}
            className="text-center mt-4"
            style={{ color: "#214382" }}
          >
            <SectionHeading text="DECLARATION/ CONFIRMATION/ UNDERTAKING" />
          </Col>
        </Row>
        <Form
          onSubmit={handleSubmit(handleUndertakingSubmit)}
          style={{ fontSize: "small" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              {...register("maker_declaration_accepted", {
                required: "Please accept this before submitting",
              })}
              style={{
                transform: "scale(1.5)",
                accentColor: "#007bff",
                cursor: "pointer",
              }}
            />
            <span>I hereby declare that the above information is true.</span>
          </div>

          {/* ✅ Display validation message */}
          {errors.maker_declaration_accepted && (
            <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              {errors.maker_declaration_accepted.message}
            </p>
          )}

          {getAppSelector.is_counterparty
            ? cpUndertaking
            : getAppSelector.business_participant_type === "Financier"
            ? financierUndertaking
            : getAppSelector.business_participant_type === "Buyer" ||
              getAppSelector.business_participant_type === "Seller"
            ? buyerSellerUndertaking
            : null}

          <Row>
            <Col md={6} className="text-start">
              <BackButton
                onClick={handleBack}
                // navigateTo={`/keyperson/kyc-details/${customerId}`} />
              />
            </Col>
            <Col md={6} className="text-end">
              {/* ⚠️ Remove onClick here — let form handle submission */}
              <Button label="Save & Next" type="submit" />
            </Col>
          </Row>
        </Form>
      </Container>
      <Row>
        <ValidationErrorModal
          showValidationModal={showValidationModal}
          onHide={() => setShowValidationModal(false)}
          error={validationError}
        />
      </Row>
    </>
  );
};

export default OpsApplicationUndertaking;
